import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@/api/baseQuery';
import { useDatasourceId } from '@/hooks';

export const GET_CATEGORIES = 'getCategories';

export const categoriesApiSlice = createApi({
  reducerPath: 'categoriesApi',
  baseQuery,
  tagTypes: [GET_CATEGORIES],
  endpoints: (builder) => ({
    [GET_CATEGORIES]: builder.query<any, any>({
      query: ({ datasourceId }) => `datasources/${datasourceId}/categories`,
      providesTags: [GET_CATEGORIES],
    }),
  }),
});

export const useGetCategoriesQuery = () => {
  const datasourceId = useDatasourceId();

  return categoriesApiSlice.useGetCategoriesQuery({ datasourceId });
};

export const usePrefetchCategories = () => {
  const datasourceId = useDatasourceId();
  const prefetch = categoriesApiSlice.usePrefetch(GET_CATEGORIES);

  return () => prefetch({ datasourceId });
};
